<template>
  <v-container fluid ma-0 pa-0 v-scroll="onScroll">
    <div>
      <v-fab-transition>
        <v-btn
          color="primary"
          fab
          x-small
          dark
          v-show="!drawer"
          @click="openSidebar"
          absolute
          style="top:15px; left:18px"
        >
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </v-fab-transition>

      <v-navigation-drawer
        color="transparent"
        width="440"
        :value="drawer"
        disable-resize-watcher
        :mobile-breakpoint="0"
        app
        clipped
        left
        style="left:56px"
      >
        <dashboard-layout-left></dashboard-layout-left>
      </v-navigation-drawer>
      <!-- If using vue-router -->

      <!-- Sizes your content based upon application components -->

      <!-- Provides the application the proper gutter -->
      <v-container fluid ma-0 pa-0>
        <!-- If using vue-router -->
        <transition-page>
          <router-view></router-view>
        </transition-page>
      </v-container>

      <v-dialog
        :key="seletFilterDialogComponentKey"
        :value="seletFilterDialogVisible"
        persistent
        max-width="850px"
      >
        <filter-selector></filter-selector>
      </v-dialog>
      <v-dialog
        :key="componentKey"
        :value="addOrEditFilterDialogVisible"
        persistent
        max-width="660px"
      >
        <filter-component></filter-component>
      </v-dialog>

      <v-dialog
        :key="saveQueryDialogComponentKey"
        :value="saveQueryDialogVisible"
        persistent
        max-width="500px"
      >
        <guardar-consulta></guardar-consulta>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import TransitionPage from "@/components/TransitionPage.vue";
import FilterComponent from "@/components/FilterComponent";
import FilterSelector from "@/components/FilterSelector";
import GuardarConsulta from "@/components/GuardarConsulta";

//Layout Components
import DashboardLayoutLeft from "@/components/DashboardLayoutLeft";
export default {
  components: {
    TransitionPage,
    DashboardLayoutLeft,
    FilterSelector,
    FilterComponent,
    GuardarConsulta
  },
  data() {
    return {
      componentKey: 0,
      seletFilterDialogComponentKey: 1000, // 1000 for prevent key colision
      saveQueryDialogComponentKey: 2000
      //drawerRight: null,
      //right: false,
      //left: false
    };
  },
  props: {},

  methods: {
    onScroll(e) {
      //console.log("e.target.scrollTop", e.target.scrollTop);
      //console.log("e.target.scrollY", e.currentTarget.scrollY);
      this.$store.dispatch("setScrollPositionAction", e.currentTarget.scrollY);
      //this.offsetTop = e.target.scrollTop
    },
    openSidebar() {
      this.$store.dispatch("toggleDashBoardDrawer");
    },
    forceRenderer() {
      this.componentKey += 1;
    },
    seletFilterDialogForceRenderer() {
      this.seletFilterDialogComponentKey += 1;
    },
    saveQueryDialogForceRenderer() {
      this.saveQueryDialogComponentKey += 1;
    }
  },
  watch: {
    addOrEditFilterDialogVisible: {
      handler: function(val) {
        if (!val) {
          setTimeout(() => this.forceRenderer(), 500);
        }
      },
      deep: true
    },
    seletFilterDialogVisible: {
      handler: function(val) {
        if (!val) {
          setTimeout(() => this.seletFilterDialogForceRenderer(), 500);
        }
      },
      deep: true
    },
    saveQueryDialogVisible: {
      handler: function(val) {
        if (!val) {
          setTimeout(() => this.saveQueryDialogForceRenderer(), 500);
        }
      },
      deep: true
    }
  },
  computed: {
    drawer() {
      return this.$store.getters.dashboardDrawer;
    },
    addOrEditFilterDialogVisible() {
      return this.$store.getters.addOrEditFilterDialogVisible;
    },
    seletFilterDialogVisible() {
      return this.$store.getters.seletFilterDialogVisible;
    },
    saveQueryDialogVisible() {
      return this.$store.getters.saveQueryDialogVisible;
    }
  }
};
</script>
